import * as Yup from "yup";

export const linkVaultInitialValues = {
  external_links: [],
};

export const linkVaultValidationSchema = Yup.object().shape({
  external_links: Yup.array().of(
    Yup.object().shape({
      title: Yup.string()
        .required("Required")
        .trim()
        .min(1, "Title cannot be empty"),
      link: Yup.string()
        .required("URL is required")
        .trim()
        .test("valid-url", "Please enter a valid URL", (value) => {
          if (!value) return false;
          try {
            // Add https:// if protocol is missing
            const urlString = value.match(/^https?:\/\//)
              ? value
              : `https://${value}`;
            const url = new URL(urlString);
            // Check if has valid hostname
            return url.hostname.includes(".");
          } catch (error) {
            return false;
          }
        }),
      is_cta_enabled: Yup.boolean().required(),
      icon: Yup.string(),
    })
  ),
});
